"use strict";

function error(options, msg) {
  if (options.onError) {
    options.onError(new Error(msg));
  }
}

module.exports = error;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/request/lib/error.js
// module id = 155
// module chunks = 0 1